import { PieChart } from '@mui/x-charts/PieChart';
import { useUser } from "../../utils/UserContext";
import { formatCurrency } from '../../utils/currencyUtils';

function Pie1({stocks, bonds, cash}) {
    const { user } = useUser();
    const valueFormatter = (item) => `${formatCurrency(item.value)}%`;
    const desktopOS = [
      {
        label: `Stocks - ${formatCurrency(stocks)}%`,
        value: parseFloat(stocks),
      },
      {
        label: `Bonds - ${formatCurrency(bonds)}%`,
        value: parseFloat(bonds),
      },
      {
        label: `Cash Reserve - ${formatCurrency(cash)}%`,
        value: parseFloat(cash),
      },
    ];

    return (
        <PieChart
            series={[
                {
                data: desktopOS,
                highlightScope: { fade: 'global', highlight: 'item' },
                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                valueFormatter,
                innerRadius: 30,
                outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                borderWidth: 0,
                },
            ]}
            height={200}
            width={200}
        />
    )
}

export default Pie1